/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
import _ from 'lodash';
import moment from 'moment';

import React, { useState, useCallback, useEffect } from 'react';
import { RadioButton, Badge } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import ThumbnailDefaultTemplate from 'src/assets/images/shopify-integration/ThumbnailDefaultTemplate.png';
import ThumbnailBasicTemplate from 'src/assets/images/shopify-integration/ThumbnailBasicTemplate.png';

const AddedByYouContent = (props: any | WithI18nProps) => {
  const { i18n, integratedTemplateInstance = {}, templateInstances = [] } = props;

  // Not integrated theme => Select first item
  let initialValue = '';
  if (_.isEmpty(integratedTemplateInstance)) {
    const firstTemplateInstance = _.get(templateInstances, '[0]', {});

    initialValue = firstTemplateInstance.templateId || '';
  } else {
    initialValue = integratedTemplateInstance.templateId || '';
  }

  const [value, setValue] = useState(initialValue);

  // Component did mount
  useEffect(() => {
    const templateInstance = _.find(templateInstances, { templateId: value });
    const { themeNameLib } = templateInstance;
    props.handleSelectTemplate(value, themeNameLib, false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Component will unmount
  useEffect(() => {
    return () => {
      // console.log('unmounted');
    };
  }, []);

  const handleChange = useCallback(
    (templateInstance: any) => {
      const { templateId, themeNameLib } = templateInstance;
      setValue(templateId);

      props.handleSelectTemplate(templateId, themeNameLib, false);
    },
    [props]
  );

  const renderItem = templateInstance => {
    const { themeNameLib, templateName, createdAt, updatedAt } = templateInstance;
    let lastSavedAt = updatedAt || createdAt;
    lastSavedAt = moment(lastSavedAt * 1000).format('MMM DD, YYYY [at] h:mm A');

    const thumbnails = {
      default: ThumbnailDefaultTemplate,
      dawn: ThumbnailBasicTemplate
    };

    const currentTemplateBadge =
      integratedTemplateInstance.templateId === templateInstance.templateId ? (
        <Badge status="success">
          {i18n.translate('AdminHTML.ShopifyIntegration.SelectTemplate.badgeCurrentTemplate')}
        </Badge>
      ) : (
        ''
      );

    return (
      <div className="item">
        <img className="thumbnail" src={thumbnails[themeNameLib]} width={50} height={40} alt="" />
        <div className="details">
          <div className="title">
            {_.upperFirst(templateName)} {currentTemplateBadge}
          </div>
          <div className="description">Last saved: {lastSavedAt}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="modal-content">
      <ul>
        {templateInstances.map(templateInstance => {
          const { templateId } = templateInstance;
          return (
            <li key={templateId}>
              <RadioButton
                label={''}
                checked={value === templateId}
                id={templateId}
                name="templateId"
                onChange={() => handleChange(templateInstance)}
              />
              {renderItem(templateInstance)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default withI18n()(AddedByYouContent);
